 import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import {  MdCloudUpload, MdDelete,MdImage, MdTitle } from 'react-icons/md';
import { deleteObject, getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from '../firebase.config';
import Loader from './Loader';
import { saveSlider,deleteSlider , getSlider } from '../utils/firebaseFunctions';
import { useStateValue } from '../context/StateProvider';
import { getAllCompany } from '../utils/firebaseFunctions';
import { actionType } from '../context/Reducer';
import Sidebar from './Sidebar';
import { IoMdQuote } from 'react-icons/io';
import { toast } from 'react-toastify';
import { FaBars } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

const AddSlider = () => {

  
  const [title, setTitle] = useState('');
  const [quotes, setQuotes] = useState('');
  const [field, setField] = useState(false);
  const [alertStatus, setAlertStatus] = useState('danger');
  const [msg, setMsg] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [imageAssest, setImageAssest] = useState(null);
  const [sliders, setSliders] = useState([]);
  const [{ Slider }, dispatch] = useStateValue();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  
  
  const toggleSidebar = (state) => {
    setIsSidebarOpen(state);
  };

  const uploadImage = (e) => {
    setIsLoading(true);
    const imageFile = e.target.files[0];
    const storageRef = ref(storage, `Images/${Date.now()}-${imageFile.name}`);
    const uploadTask = uploadBytesResumable(storageRef, imageFile);

    uploadTask.on('state_changed',
      (snapshot) => {
        const uploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log(`Upload is ${uploadProgress}% done`);
      },
      (error) => {
        console.error(error);
        setField(true);
        setMsg("Error while uploading: Try again");
        setAlertStatus('danger');
        setTimeout(() => {
          setField(false);
          setIsLoading(false);
        }, 4000);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          console.log("File available at", downloadURL);
          setImageAssest(downloadURL);
          setIsLoading(false);
          setField(true);
          setMsg("Image uploaded successfully");
          setAlertStatus("success");
          setTimeout(() => {
            setField(false);
          }, 4000);
        });
      }
    );
  };

  const deleteImage = () => {
    if (!imageAssest) {
      setField(true);
      setMsg("No image to delete");
      setAlertStatus("warning");
      setTimeout(() => {
        setField(false);
      }, 4000);
      return;
    }

    setIsLoading(true);
    const deleteRef = ref(storage, imageAssest);
    deleteObject(deleteRef)
      .then(() => {
        setImageAssest(null);
        setIsLoading(false);
        setField(true);
        setMsg("Image deleted successfully");
        toast.success("Image deleted successfully!");
        setAlertStatus("success");
        setTimeout(() => {
          setField(false);
        }, 4000);
      })
      .catch((error) => {
        console.error("Error deleting image:", error);
        setIsLoading(false);
        setField(true);
        setMsg("Error while deleting: Try again");
        setAlertStatus("danger");
        setTimeout(() => {
          setField(false);
        }, 4000);
      });
  };

  const saveDetails = () => {
    setIsLoading(true);
    try {
      if (!title || !imageAssest ) {
        setField(true);
        setMsg("Required fields can't be empty");
        setAlertStatus('danger');
        setTimeout(() => {
          setField(false);
          setIsLoading(false);
        }, 4000);
      } else {
        const data = {
          id: `${Date.now()}`,
          title: title,
          quotes:quotes,
          imageurl: imageAssest,
          
        };
        saveSlider(data);
        console.log('Data to save:', data);
        toast.success("Slider details saved successfully!");
        setIsLoading(false);
        setField(true);
        setMsg("Details saved successfully");
        clearData();
        setTimeout(() => {
          setField(false);
        }, 4000);
      }
    } catch (error) {
      console.error(error);
      setField(true);
      setMsg("Error while saving: Try again");
      setAlertStatus('danger');
      setTimeout(() => {
        setField(false);
        setIsLoading(false);
      }, 4000);
    }
    fetchSliderData();
  };

  const clearData = () => {
    setTitle('');
    setImageAssest('');
    setQuotes('');
  };
  useEffect(() => {
    fetchSliderData();
  }, []);
  
  const fetchSliderData = async () => {
    const data = await getSlider(); // Fetch data using the function
    setSliders(data); // Update the local state with slider data
  };

  const handleDeleteSlider = async (id, imageUrl) => {
    // Show confirmation dialog
    const isConfirmed = window.confirm("Are you sure you want to delete this slider?");
    
    if (isConfirmed) {
      try {
        await deleteSlider(id, imageUrl);
        toast.success("Slider deleted successfully!");
        fetchSliderData(); // Refresh slider data after deletion
      } catch (error) {
        console.error("Error deleting slider:", error);
        toast.error("Error deleting slider. Please try again.");
      }
    } else {
      toast.info("Slider deletion cancelled.");
    }
  };
  

  return (
    <div className='lg:flex h-2000 overflow-hidden mt-16'>
      <Helmet>
      <title>Add Slider - Admin Panel</title>
      <meta name="description" content="Add and manage slider images with titles and quotes." />
    </Helmet>
    <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

    <div className={`flex-1 overflow-y-auto transition-all duration-300 lg:mt-2 mt-10 p-4 
          ${isSidebarOpen ? "ml-56 p-2 mr-[-16px] " : "lg:ml-20 sm:ml-2 lg:p-8 sm:p-6"}`}  
        >
        <div className='w-full max-w-3xl mx-auto'>
        <h1 className="text-2xl font-semibold mb-3">Add Slider</h1>
          <div className='space-y-4 border-gray-300 rounded-lg'>
          {field && (
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className={`w-full p-2 rounded-lg text-center text-lg font-semibold ${alertStatus === "danger" ? "bg-red-400 text-red-800" : alertStatus === "success" ? "bg-green-400 text-green-800" : "bg-yellow-400 text-yellow-800"
                  }`}
              >
                {msg}
              </motion.p>
            )}
            
            <div className='flex items-center border-b border-gray-300 py-2'>
              <MdTitle className='text-xl text-gray-700' />
              <input
                type="text"
                className='w-full h-full lg:text-lg text-[14px] bg-transparent outline-none border-none placeholder:text-gray-400 text-gray-900 pl-3'
                required
                value={title}
                placeholder='Enter Slider content'
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className='flex items-center border-b border-gray-300 py-2'>
              <IoMdQuote className='text-xl text-gray-700' />
              <input
                type="text"
                className='w-full h-full lg:text-lg text-[14px] bg-transparent outline-none border-none placeholder:text-gray-400 text-gray-900 pl-3'
                required
                value={quotes}
                placeholder='Enter Qoutes'
                onChange={(e) => setQuotes(e.target.value)}
              />
            </div>
  
           
            <button
  type="button"
  className="relative inline-block border border-[#005eb8] text-[#005eb8] lg:text-[16px] text-[14px] font-[500] leading-[1.5] px-[30px] py-[10px]  transition-all duration-200 hover:bg-[#005eb8] hover:text-white"
  onClick={saveDetails}
  aria-label="Save details"
>
  Save
</button>


          </div>
            {/* Table Section */}
            <div className='mt-8 overflow-x-auto'>
        <h2 className='text-lg font-semibold'>Slider Details</h2>
        {sliders.length === 0 ? (
  <p>No slider data available.</p>
) : (
        <table className='min-w-full border-collapse border border-gray-300'>
          <thead>
            <tr className='bg-gray-200'>
              <th className='border border-gray-300 px-4 py-2'>ID</th>
              <th className='border border-gray-300 px-4 py-2'>Title</th>
              <th className='border border-gray-300 px-4 py-2'>Quotes</th>
              <th className='border border-gray-300 px-4 py-2'>Actions</th>
            </tr>
          </thead>
          <tbody>
            {sliders.map((slider) => (
              <tr key={slider.id}>
                <td className='border border-gray-300 px-4 py-2'>{slider.id}</td>
                <td className='border border-gray-300 px-4 py-2'>{slider.title}</td>
                <td className='border border-gray-300 lg:text-md text-[13px] px-4 py-2'>{slider.quotes}</td>
                <td className='border border-gray-300 px-4 py-2 text-center'>
                  <button onClick={() => handleDeleteSlider(slider.id, slider.imageurl)}>
                    <MdDelete className='text-red-600 text-xl' />
                  </button>
                  
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        )}
      </div>
        </div>

      </div>
    </div>
  );
  
};

export default AddSlider;

